export default __webpack_public_path__ + "img/92f44e19b2abad8302c69219595e44a6.svg";